<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn x-large class="myYellow2 ml-8" to="/">
                    <v-icon left>mdi-chevron-left</v-icon> HOME
                </v-btn>
            </v-col>
        </v-row>
        <v-card class="ma-8 pb-2">
            <v-breadcrumbs :items="breadcrumbs">
                <template v-slot:divider>
                    <v-icon>mdi-chevron-right</v-icon>
                </template>
            </v-breadcrumbs>

            <v-card class="mx-8">
                <FilterMenu />
            </v-card>

            <v-card class="ma-6 pa-4" color="grey">
                <v-row>
                    <v-col cols="12" sm="6" v-for="(item, id) in items" :key="id">
                        <CardMenu
                            :item="item"
                            :discount="item.menu_discount != 0"
                            :quantity="getQuantity(item)"
                            @addMenu="ADD_TO_CART(item)"
                            @plusMenu="ADD_QUANTITY(item.id)"
                            @minusMenu="REDUCE_QUANTITY(item.id)"
                        />
                    </v-col>
                </v-row>
            </v-card>

            <v-card class="ma-6 pa-2 d-flex justify-space-between" v-if="cart.length">
                <div class="text-h6 font-weight-bold">CART TOTAL ({{ totalQuantity }})</div>
                <div class="text-h6 font-weight-bold">{{ parseRupiah(totalPrice) }},-</div>
            </v-card>

            <v-card class="ma-6 pa-6 d-flex justify-space-between">
                <v-btn text class="myGreen--text" to="/neworder"
                    ><v-icon left>mdi-chevron-left</v-icon> Back</v-btn
                >
                <v-btn class="myGreen white--text" to="/newcart">
                    Next <v-icon right>mdi-chevron-right</v-icon>
                </v-btn>
            </v-card>
        </v-card>
    </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CardMenu from "../components/NewMenu/CardMenu";
import FilterMenu from "../components/NewMenu/FilterMenu";

export default {
    components: {
        CardMenu,
        FilterMenu,
    },
    data: () => ({
        breadcrumbs: [
            {
                text: "Form",
                disabled: false,
                href: "/neworder",
            },
            {
                text: "Menu",
                disabled: false,
                href: "/newmenu",
            },
            {
                text: "Payment Method",
                disabled: true,
                href: "/newcart",
            },
            {
                text: "Done",
                disabled: true,
                href: "/",
            },
        ],
        search: "",
    }),

    computed: {
        ...mapGetters(["items", "cart"]),
        totalQuantity() {
            return this.cart.reduce((a, b) => a + b.quantity, 0);
        },
        totalPrice() {
            return this.cart.reduce(
                (a, b) => a + b.quantity * b.price - (b.price * b.quantity * b.menu_discount) / 100,
                0
            );
        },
    },
    methods: {
        ...mapActions(["GET_ITEMS", "ADD_TO_CART", "ADD_QUANTITY", "REDUCE_QUANTITY"]),
        getQuantity(item) {
            let quantity = 0;
            for (var cartItem of this.cart) {
                if (item.id == cartItem.id) {
                    quantity = cartItem.quantity;
                }
            }
            return quantity;
        },
        parseRupiah(price) {
            if (price == null) {
                return "";
            } else {
                return "Rp " + price.toString().replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1.");
            }
        },
    },
    mounted() {
        this.GET_ITEMS();
    },
};
</script>
